import Vue from 'vue';

import wysiwyg from 'vue-wysiwyg';
import Element from 'element-ui';
// import Vuetify from 'vuetify';

import enElementLocale from 'element-ui/lib/locale/lang/en';

import i18n from '@/i18n/index';

const en = i18n.getLocaleMessage('en');
i18n.setLocaleMessage('en', { ...en, ...enElementLocale });

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value),
});

Vue.use(wysiwyg, {});
// Vue.use(Vuetify);



// WEBPACK FOOTER //
// ./src/ui/index.js